import { Page } from "@synota-io/synota-shared-ui";
import { generatePath, Navigate, useParams } from "react-router-dom";
import { Typography } from "@mui/material";
import { USER_ACCOUNT_PATH } from "../../../paths";
import { useUsers } from "../../../api/hooks/useUsers";

export const UsersPage = () => {
  const { users } = useUsers();
  const { id } = useParams();

  if (id) {
    return <Navigate to={generatePath(USER_ACCOUNT_PATH, { id })} />;
  }

  if (users?.[0]?.uuid) {
    return <Navigate to={generatePath(USER_ACCOUNT_PATH, { id: users[0].uuid })} />;
  }

  return (
    <Page>
      <Typography variant="h5">There's nothing here</Typography>
    </Page>
  );
};
